

/* CANVA */
export const LOADING_CANVA = "LOADING_CANVA";
export const WAITING_DATA_CANVA = "WAITING_DATA_CANVA";
export const BAR_HIDDEN_CANVA = "BAR_HIDDEN_CANVA";
export const IS_SIDEBAR_HOME_CANVA = "IS_SIDEBAR_HOME_CANVA";
export const IS_VISITA_MAP_CANVA = "IS_VISITA_MAP_CANVA";

export const SHOWED_MAP_CANVA = "SHOWED_MAP_CANVA";
export const SELECTED_TORRE_CANVA = "SELECTED_TORRE_CANVA";
export const SELECTED_APTO_TIPO_CANVA = "SELECTED_APTO_TIPO_CANVA";
export const SELECTED_NUMERO_APTO_CANVA = "SELECTED_NUMERO_APTO_CANVA";
export const INDEX_APTO_TIPO_CANVA = "INDEX_APTO_TIPO_CANVA";
export const TIPOS_APTOS_COTIZADOS_CANVA = "TIPOS_APTOS_COTIZADOS_CANVA";
export const SELECTED_APTOS_CANVA = "SELECTED_APTOS_CANVA";
export const SELECTED_FLOOR_CANVA = "SELECTED_FLOOR_CANVA";

export const APTO_TIPO_OPENED_CANVA = "APTO_TIPO_OPENED_CANVA";
export const OPEN_GALERIA_CANVA = "OPEN_GALERIA_CANVA";
export const OPEN_360_CANVA = "OPEN_360_CANVA";
export const SELECTED_POI_CANVA = "SELECTED_POI_CANVA";
export const IS_FORM_COTIZACION_CANVA = "IS_FORM_COTIZACION_CANVA";

export const LINKS_CANVA = "LINKS_CANVA";
export const LINK_TRANSITION_CANVA = "LINK_TRANSITION_CANVA";
export const IS_TRANCITION_CANVA = "IS_TRANCITION_CANVA";
export const INIT_FRAME_POI_CANVA = "INIT_FRAME_POI_CANVA";
export const IS_PRE_TRANSITION_CANVA = "IS_PRE_TRANSITION_CANVA";

export const APTOS_COTIZADOS_CANVA = "APTOS_COTIZADOS_CANVA";

export const IS_180_CANVA = "IS_180_CANVA";
export const SHOW_GENERAL_VIEW_CANVA = "SHOW_GENERAL_VIEW_CANVA";
export const IS_IMAGE_360_CANVA = "IS_IMAGE_360_CANVA";
export const SHOW_BUBBLES_CANVA = "SHOW_BUBBLES_CANVA";
export const SHOW_BILLBOARDS_CANVA = "SHOW_BILLBOARDS_CANVA";

export const CATEGORY_FILTER_CANVA = "CATEGORY_FILTER_CANVA";
export const TORRE_FILTER_CANVA = "TORRE_FILTER_CANVA";
export const APTO_FILTER_CANVA = "APTO_FILTER_CANVA";
export const AMENITY_CANAVA = "AMENITY_CANAVA";
export const SHOWING_TORRES_SPIN_CANVA = "SHOWING_TORRES_SPIN_CANVA";
export const TOWER_TRANSITION_CANVA = "TOWER_TRANSITION_CANVA";

export const ROTATE_FOR_BUBBLE_CANVA = "ROTATE_FOR_BUBBLE_CANVA";

export const SELECTED_ZONA_INTERES_CANVA = "SELECTED_ZONA_INTERES_CANVA";

export const MAIN_CAMERA_ANGLE_CANVA = "MAIN_CAMERA_ANGLE_CANVA";
export const BTN_SELECTED_CANVA = "BTN_SELECTED_CANVA";
export const IS_AMENIDADES_CANVA = "IS_AMENIDADES_CANVA";
export const IS_ETAPAS_CANVA = "IS_ETAPAS_CANVA";
export const IS_ZONAS_INTERES_CANVA = "IS_ZONAS_INTERES_CANVA";
export const IS_VIAS_CANVA = "IS_VIAS_CANVA";
export const SELECTED_APTO_CANVA = "SELECTED_APTO_CANVA";
export const INIT_FRAME_180_CANVA = "INIT_FRAME_180_CANVA";
export const BUBBLE_ANGLE_CANVA = "BUBBLE_ANGLE_CANVA";
export const CAMERA_ANGLE_CANVA = "CAMERA_ANGLE_CANVA";
export const ANIMATE_CANVA = "ANIMATE_CANVA";
export const IS_PLANO_CANVA = "IS_PLANO_CANVA";
export const BTN_SELECTED_2_CANVA = "BTN_SELECTED_2_CANVA";

export const OPEN_VIDEO_CANVA = "OPEN_VIDEO_CANVA";
export const HAS_VIDEO_CANVA = "HAS_VIDEO_CANVA";
export const CURRENT_VIDEO_CANVA = "CURRENT_VIDEO_CANVA";

export const FULL_UPDATE_CANVAS = "FULL_UPDATE_CANVAS";



/* WELCOME */
export const LOADING_WELCOME = "LOADING_WELCOME";
export const INGRESO_WELCOME = "INGRESO_WELCOME";
export const IMAGES_WELCOME = "IMAGES_WELCOME";
export const CACHED_IMAGES = "CACHED_IMAGES";
export const PROYECTOS_WELCOME = "PROYECTOS_WELCOME";
export const INITIAL_PROYECTOS_WELCOME = "INITIAL_PROYECTOS_WELCOME";
export const TEXTURES_WELCOME = "TEXTURES_WELCOME";
export const LOADED_IMAGES_WELCOME = "LOADED_IMAGES_WELCOME";
export const STEP_WELCOME = "STEP_WELCOME";


export * from "./canva/actions";
export * from "./welcome/actions";
